import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['checkbox'];

  connect() { // eslint-disable-line class-methods-use-this
    window.checkboxStates = window.checkboxStates || {};
  }

  load() { // eslint-disable-line class-methods-use-this
    Object.keys(window.checkboxStates).forEach((elId) => {
      const el = document.querySelector(`#${elId}`);
      if (!el) return;
      el.checked = true; // eslint-disable-line no-param-reassign
      Rails.fire(el, 'changed');
    });
  }

  toggleScroll(event) {
    if (this.checkboxTarget.checked) {
      this.lockScroll(event);
    } else {
      this.unlockScroll(event);
    }
  }

  lockScroll(event) {
    if (event.target) window.checkboxStates[event.target.id] = true;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    this.saveScrollPosition();

    document.body.classList.add('fixed', 'inset-x-0', 'overflow-hidden');
  }

  unlockScroll(event) {
    if (event.target) delete window.checkboxStates[event.target.id];
    document.body.style.paddingRight = null;

    document.body.classList.remove('fixed', 'inset-x-0', 'overflow-hidden');

    this.restoreScrollPosition();

    document.body.style.top = null;
  }

  resizeEnd() {
    this.checkboxTarget.checked = false;
    Rails.fire(this.checkboxTarget, 'change');
  }

  saveScrollPosition() {
    this.scrollPosition = window.pageYOffset || document.body.scrollTop;
  }

  restoreScrollPosition() {
    document.documentElement.scrollTop = this.scrollPosition;
  }
}
